import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "df-card" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationCard',
    setup(__props) {
        /**
         * DonationCard — a pure presentational card wrapper. SYNC: see ../../_SYNC.md.
         * Holds no state; renders its default slot inside a styled, elevated surface.
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
